var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{staticClass:"title",attrs:{"title":"收藏列表","left-arrow":""},on:{"click-left":function($event){return _vm.$router.go(-1)}}}),_vm._l((_vm.list),function(item,index){return _c('collect-items',{key:index,attrs:{"item":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }